export const COMPANY_PAGE_STATISTICS = "company_page_statistics"
